<template>
  <div
    ref="box"
    style="display:none;"
    class="homContent"
  >
    <!-- 头部 -->
    <div class="operationLog-header">
      <header-top
        @operationLogSearchKeyword="getKeyword"
        @operationLogDate="changeDate"
        @changeVal="getChangeOperatPla"
        @changeSel="getChangeEventType"
      ></header-top>
    </div>
    <!-- 表格部分 -->
    <div class="table-content">
      <table-content
        :table-list="tableData.list"
        :loading="operationLogLoading"
      ></table-content>
    </div>
    <div class="table-pagination">
      <page-component
        :total="total"
        :current-page="page"
        @pagechange="getOperationLogTableList"
        v-if="getOperationLogTableList.length > 0"
      ></page-component>
    </div>
  </div>
</template>

<script>
// 头部
import HeaderTop from "./include/header";
// 表格内容
import TableContent from "./include/table";
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import { getCity } from "@/requests/bar"
import { getOperationLogTableList } from "@/requests/operationLog";
export default {
  name: "operationLog",
  components: {
    HeaderTop,
    TableContent,
    PageComponent
  },
  data() {
    return {
      total: 0,
      page: 1,
      tableData: {
        list: []
      },
      searchTxt: "",
      beginDate: "",
      endDate: "",
      operatPlarform: "",
      eventType: "",
      operationLogLoading: false,
      cityName: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        // this.$domFn.addAnimateClass(this.$refs.box, 'animated fadeInRight')
        this.$refs.box.style.display = "block";
      });
    });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getOperationLogTableList(1);
    });
  },
  methods: {
    getKeyword(data) {
      this.searchTxt = data;
      this.getOperationLogTableList(1);
    },
    changeDate(data, data2) {
      this.beginDate = data;
      this.endDate = data2;
      this.getOperationLogTableList(1);
    },
    getChangeOperatPla(data) {
      this.operatPlarform = data;
      this.getOperationLogTableList(1);
    },
    getChangeEventType(data) {
      this.eventType = data;
      this.getOperationLogTableList(1);
    },
    // 获取操作日志列表
    async getOperationLogTableList(page) {
      this.operationLogLoading = true;
      let res = await getOperationLogTableList({
        pageNum: page,
        pageSize: 20,
        operationRemark: this.searchTxt,
        beginDate: this.beginDate,
        endDate: this.endDate,
        operationSource: this.operatPlarform,
        operation: this.eventType
      });
      res.records.forEach(element => {
        this.getCity(element.ip).then(res2 =>
          element.areaName = res2
        )
      });
      this.tableData.list = res.records;
      this.total = parseInt(res.total);
      this.page = parseInt(res.current);
      this.operationLogLoading = false;
    },
    async getCity(ip) {
      let res = await getCity(ip)
      if (res != '' && res.province != '' && res.province != undefined) {
        return res.province + '-' + res.city
      } else {
        return '--'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.homContent {
  position: absolute;
  min-width: 1090px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
}
.operationLog-header {
  height: 70px;
  // line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}
.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
.table-pagination {
  padding: 20px 80px 20px 0px;
  display: inline-block;
}
</style>
